import { FormCheckbox, FormFieldGroup, FormGroup, FormInput, FormLabel, FormTextarea } from '$components'
import { z } from 'zod'
import { Input } from './shared/types'

export type MedicalInformationSchema = z.infer<typeof medicalInformationSchema>

export const medicalInformationSchema = z.object({
  [Input.MicrochipNumber]: z.string()
    .max(255, { message: 'Microchip number must be less than 255 characters.' })
    .optional(),
  [Input.Weight]: z.number()
    .min(0, { message: 'Weight must be greater than 0.' })
    .max(1000, { message: 'Weight must be less than 1000.' })
    .or(z.nan())
    .optional(),
  [Input.Vet]: z.object({
    [Input.VetName]: z.string()
      .max(255, { message: 'Vet name must be less than 255 characters.' })
      .optional(),
    [Input.VetPhone]: z.string()
      .max(32, { message: 'Vet phone number must be less than 32 characters.' })
      .optional(),
  }).optional(),
  [Input.Vaccinated]: z.boolean().optional(),
  [Input.Allergies]: z.string()
    .max(2048, { message: 'Allergies must be less than 2048 characters.' })
    .optional(),
  [Input.MedicalNotes]: z.string()
    .max(2048, { message: 'Medical notes must be less than 2048 characters.' })
    .optional(),
})

export function MedicalInformationStep() {

  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.MicrochipNumber}>
          Microchip Number
        </FormLabel>

        <FormInput
          name={Input.MicrochipNumber}
          placeholder="Enter microchip number..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Weight}>
          Weight
        </FormLabel>

        <FormInput
          name={Input.Weight}
          type="number"
          min={0}
          placeholder="0.00"
        />
      </FormFieldGroup>

      <FormGroup label="Veterinary Information">
        <FormFieldGroup>
          <FormLabel htmlFor={Input.Vet}>
            Vet Name
          </FormLabel>

          <FormInput
            name={Input.VetName}
            placeholder="Enter vet name..."
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={Input.VetPhone}>
            Vet Phone
          </FormLabel>

          <FormInput
            name={Input.VetPhone}
            placeholder="Enter vet phone number..."
          />
        </FormFieldGroup>

        <FormFieldGroup className="my-stack-tight">
          <FormCheckbox
            name={Input.Vaccinated}
            label="Is Vaccinated?"
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={Input.Allergies}>
            Allergies
          </FormLabel>

          <FormTextarea
            name={Input.Allergies}
            placeholder="Enter allergies..."
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={Input.MedicalNotes}>
            Medical Notes
          </FormLabel>

          <FormTextarea
            name={Input.MedicalNotes}
            placeholder="Enter medical notes..."
          />
        </FormFieldGroup>
      </FormGroup>
    </div>
  )
}
